import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { checkIsMobile } from '../utils/checkDevice'
import PCHome from '../views/computer/Home/Home.vue'
import MHome from '../views/mobile/Home/Home.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const Device = checkIsMobile() ? 'mobile' : 'computer'
const Home = checkIsMobile() ? MHome : PCHome

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/block',
    component: () => import(`../views/${Device}/Block/Block.vue`)
  },
  {
    path: '/tradelist',
    component: () => import(`../views/${Device}/Trade/Trade.vue`)
  },
  {
    path: '/blockDetail',
    component: () => import(`../views/${Device}/Block/BlockDetail.vue`)
  },
  {
    path: '/address',
    component: () => import(`../views/${Device}/Address/Address.vue`)
  },
  {
    path: '/token',
    component: () => import(`../views/${Device}/Token/Token.vue`)
  },
  {
    path: '/tokenDetail',
    component: () => import(`../views/${Device}/Token/TokenDetail.vue`)
  },
  {
    path: '/tradeHash',
    component: () => import(`../views/${Device}/Trade/TradeDetail.vue`)
  },
  {
    path: '/alytx',
    component: () => import(`../views/${Device}/Tool/Anylise.vue`)
  },
  {
    path: '/broadtx',
    component: () => import(`../views/${Device}/Tool/BroadCast.vue`)
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
  window.scrollTo(0, 0)
})

export default router
